// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.social-listing-loader {
  height: 86vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  color: #1c1c1c;
  overflow: hidden;
}

.social-listing-loader__card {
  max-width: 720px;
  width: 100%;
  text-align: center;
}

.social-listing-loader__title {
  margin: 16px 0 8px;
  font-size: 28px;
  font-weight: 700;
  font-style: "opensans", sans-serif;
  line-height: 1.3;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: #000000;
}

.social-listing-loader__spinner {
  width: 18px;
  height: 18px;
  border: 3px solid #cfd9f2;
  border-top-color: #2f66c8;
  border-radius: 50%;
  animation: social-listing-spin 0.9s linear infinite;
}

.social-listing-loader__subtitle {
  margin: 0 0 6px;
  color: #7a7a7a;
  font-size: 14px;
  font-weight: 400;
  font-style: "opensans", sans-serif;
}

.social-listing-loader__note {
  margin: 0;
  color: #2C68AD;
  font-size: 14px;
  font-weight: 700;
  font-style: "opensans", sans-serif;
}

.social-listing-loader__animation {
  margin: 28px auto 0;
  display: block;
  width: min(560px, 100%);
  height: auto;
  margin-top: -150px;
}

@keyframes social-listing-spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 640px) {
  .social-listing-loader__title {
    font-size: 22px;
  }
  .social-listing-loader__animation {
    width: min(420px, 100%);
  }
}`, "",{"version":3,"sources":["webpack://./src/layouts/SocialListingAgent/loader.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,gBAAA;EACA,WAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kCAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mDAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACD,kCAAA;AACD;;AAEA;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACC,kCAAA;AACH;;AAEA;EACE,mBAAA;EACA,cAAA;EACA,uBAAA;EACA,YAAA;EACI,kBAAA;AACN;;AAEA;EACE;IACE,yBAAA;EACF;AACF;AAEA;EACE;IACE,eAAA;EAAF;EAGA;IACE,uBAAA;EADF;AACF","sourcesContent":[".social-listing-loader {\n  height: 86vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #fff;\n  color: #1c1c1c;\n  overflow: hidden;\n}\n\n.social-listing-loader__card {\n  max-width: 720px;\n  width: 100%;\n  text-align: center;\n}\n\n.social-listing-loader__title {\n  margin: 16px 0 8px;\n  font-size: 28px;\n  font-weight: 700;\n  font-style: 'opensans', sans-serif;\n  line-height: 1.3;\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  color: #000000;\n}\n\n.social-listing-loader__spinner {\n  width: 18px;\n  height: 18px;\n  border: 3px solid #cfd9f2;\n  border-top-color: #2f66c8;\n  border-radius: 50%;\n  animation: social-listing-spin 0.9s linear infinite;\n}\n\n.social-listing-loader__subtitle {\n  margin: 0 0 6px;\n  color: #7a7a7a;\n  font-size: 14px;\n  font-weight: 400;\n font-style: 'opensans', sans-serif;\n}\n\n.social-listing-loader__note {\n  margin: 0;\n  color: #2C68AD;\n  font-size: 14px;\n  font-weight: 700;\n   font-style: 'opensans', sans-serif;\n}\n\n.social-listing-loader__animation {\n  margin: 28px auto 0;\n  display: block;\n  width: min(560px, 100%);\n  height: auto;\n      margin-top: -150px;\n}\n\n@keyframes social-listing-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@media (max-width: 640px) {\n  .social-listing-loader__title {\n    font-size: 22px;\n  }\n\n  .social-listing-loader__animation {\n    width: min(420px, 100%);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
